module.exports = __webpack_public_path__ + "static/media/linux.bea5aacd.svg";